"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var SignatureCertificate = (function (_super) {
    __extends(SignatureCertificate, _super);
    function SignatureCertificate(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = _this.onChange.bind(_this);
        _this.json_data = props.model.json_data;
        _this.onModel = _this.onModel.bind(_this);
        props.model.dispatcher.addListener(_this.onModel);
        return _this;
    }
    SignatureCertificate.prototype.onModel = function () {
        this.json_data = this.props.model.json_data;
        this.forceUpdate();
    };
    SignatureCertificate.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.dispatcher.dispatch();
                return [2];
            });
        });
    };
    SignatureCertificate.prototype.componentWillUnmount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.removeValidateFunction(this.constructor.name);
                this.props.model.dispatcher.removeListener(this.onModel);
                return [2];
            });
        });
    };
    SignatureCertificate.prototype.onChange = function (id, value) {
        this.json_data[id] = value;
        this.forceUpdate();
    };
    SignatureCertificate.prototype.render = function () {
        var _a = this, json_data = _a.json_data, onChange = _a.onChange;
        var src = this.json_data.signature || "#";
        return (React.createElement("div", null,
            React.createElement("div", { className: "gray-line" }),
            React.createElement("section", { className: "section-content" },
                React.createElement("h2", { className: "section-title" }, "Signature Certificate"),
                React.createElement("table", { className: "table" },
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", null,
                                React.createElement("p", null,
                                    json_data["first_name"],
                                    " ",
                                    json_data["last_name"]),
                                json_data["email"] && React.createElement("p", null, "email " + json_data["email"]),
                                json_data["ip"] && React.createElement("p", null, "IP address " + json_data["ip"]),
                                json_data["created_at"] && (React.createElement("p", null, "Timestamp " + json_data["created_at"]))),
                            React.createElement("td", null,
                                React.createElement("img", { src: src, width: "200", height: "100" }))))))));
    };
    return SignatureCertificate;
}(react_1.Component));
exports.SignatureCertificate = SignatureCertificate;
//# sourceMappingURL=data:application/json;base64,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